import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import { getDiscoveryBaseFilters } from "../../../../utils/entitiesFiltersUtils";
import CourseGalleryItem from "../../../features/courseGallery/courseGalleryItem/CourseGalleryItem";
import classes from "./DiscoverySearchResults.module.css";

const DiscoverySearchResults = ({ filters }) => {
    
    const { texts } = useSelector(state => state.translate);

    const filteredCourses = useSelector((state) =>
        selectEntitiesByFilters(state, [
            ...getDiscoveryBaseFilters(state.auth.user?.studentkita),
            ...filters,
        ])
    );


    if (!filteredCourses || filteredCourses.length === 0) {
        return (
            <div className={classes.DiscoverySearchResults}>
                <div className={classes.NoResults}>
                    <h3>{texts.discoverySearchNoResultsTitle}</h3>
                    <p>{texts.discoverySearchNoResultsHint}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.DiscoverySearchResults}>
            <div className={classes.ResultsHeader}>
                <h2>{texts.discoverySearchResultsTitle}</h2>
                <span className={classes.ResultsCount}>
                    {texts.discoverySearchResultsCount?.replace("{count}", String(filteredCourses?.length ?? 0))}
                </span>
            </div>

            <div className={classes.ResultsGrid}>
                {filteredCourses.map((course, index) => (
                    <div key={`${course.externalId}_${course.providerName ?? index}`} className={classes.ResultItem}>
                        <CourseGalleryItem course={course} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DiscoverySearchResults; 